module.exports = __webpack_public_path__ + "static/img/sanhe_main_tit2.a28fef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductDetails/assets/sanhe_main_tit2.png
// module id = mJlc
// module chunks = 19